import { ComposerBasePost } from './ComposerBasePost'

export type GooglePostButtonType = 'BOOK' | 'ORDER' | 'SHOP' | 'LEARN_MORE' | 'SIGN_UP' | 'CALL'
export const GOOGLE_POST_TYPE_UPDATE = 'update'
export const GOOGLE_POST_TYPE_OFFER = 'offer'
export const GOOGLE_POST_TYPE_EVENT = 'event'

export interface ComposerGooglePost extends ComposerBasePost {
  selectedPostType: typeof GOOGLE_POST_TYPE_UPDATE | typeof GOOGLE_POST_TYPE_OFFER | typeof GOOGLE_POST_TYPE_EVENT
  update: {
    buttonType?: GooglePostButtonType
    link: string
  }
  offer: {
    offer: {
      couponCode?: string
      redeemOnlineUrl: string
      termsConditions?: string
    }
    event: {
      title: string
      schedule: {
        startDate: string
        endDate: string
      }
    }
  }
  event: {
    title: string
    schedule: {
      startDate: string
      endDate: string
    }
  }
}
